import { connect } from "react-redux";
import Donate from "./components";

const mapStateToProps = (state) => ({
  lastOrder: state.cart.lastOrder,
});

export default connect(mapStateToProps)(Donate);
